import { Header } from "@/components/layout/Header";

export const TestLoading = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      <main className="container mx-auto px-4 py-8">
        <div className="flex items-center justify-center">
          Loading test...
        </div>
      </main>
    </div>
  );
};